import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import pt from './locales/pt.json';
import en from './locales/en.json';
import ja from './locales/ja.json';

// Course definitions with their native languages
export const COURSES = {
  'pt-en': {
    id: 'pt-en',
    name: 'Inglês para Brasileiros',
    nameNative: 'Inglês para Brasileiros',
    sourceLanguage: 'pt',
    targetLanguage: 'inglês',
    targetLanguageCode: 'en',
    flag: '🇧🇷 → 🇺🇸',
    description: 'Aprenda inglês do zero ao avançado',
    descriptionNative: 'Aprenda inglês do zero ao avançado'
  },
  'pt-ja': {
    id: 'pt-ja',
    name: 'Japonês para Brasileiros',
    nameNative: 'Japonês para Brasileiros',
    sourceLanguage: 'pt',
    targetLanguage: 'japonês',
    targetLanguageCode: 'ja',
    flag: '🇧🇷 → 🇯🇵',
    description: 'Aprenda japonês do zero ao avançado',
    descriptionNative: 'Aprenda japonês do zero ao avançado'
  },
  'en-ja': {
    id: 'en-ja',
    name: 'Japanese for English Speakers',
    nameNative: 'Japanese for English Speakers',
    sourceLanguage: 'en',
    targetLanguage: 'Japanese',
    targetLanguageCode: 'ja',
    flag: '🇺🇸 → 🇯🇵',
    description: 'Learn Japanese from beginner to advanced',
    descriptionNative: 'Learn Japanese from beginner to advanced'
  },
  'ja-en': {
    id: 'ja-en',
    name: 'English for Japanese',
    nameNative: '英語コース (日本人向け)',
    sourceLanguage: 'ja',
    targetLanguage: '英語',
    targetLanguageCode: 'en',
    flag: '🇯🇵 → 🇺🇸',
    description: 'Learn English from beginner to advanced',
    descriptionNative: '初級から上級まで英語を学ぶ'
  },
  'ja-pt': {
    id: 'ja-pt',
    name: 'Portuguese for Japanese',
    nameNative: 'ポルトガル語コース (日本人向け)',
    sourceLanguage: 'ja',
    targetLanguage: 'ポルトガル語',
    targetLanguageCode: 'pt',
    flag: '🇯🇵 → 🇧🇷',
    description: 'Learn Portuguese from beginner to advanced',
    descriptionNative: '初級から上級までポルトガル語を学ぶ'
  }
};

// Get interface language from course
export const getInterfaceLanguage = (courseId) => {
  const course = COURSES[courseId];
  return course ? course.sourceLanguage : 'pt';
};

const resources = {
  pt: { translation: pt },
  en: { translation: en },
  ja: { translation: ja }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
